<template>

    <!--<div class="mx-auto w-1/3 h-64 bg-theme-level4 border border-theme-level3 shadow-lg mt-10 flex flex-col items-center rounded-lg">
        <h2 class="font-bold text-lg text-theme-title mt-8">Login</h2>
        <p class="text-theme-main p-6">This will be the Login form called from Vue Router</p>
    </div>-->

    <div class="container mx-auto mt-20">
        <div class="flex flex-wrap justify-center">
            <div class="w-full max-w-sm">
                <div class="flex flex-col break-words bg-theme-level4 border border-2 border-theme-level3 rounded-lg shadow-lg">

                    <div class="font-semibold bg-theme-dialogbackground text-theme-dialogtitles py-3 px-6 mb-0 rounded-t-lg">
                        Iniciar Sesión
                    </div>

                    <form class="w-full p-6" method="POST" action="">

                        <div class="flex flex-wrap mb-6">
                            <label for="email" class="block text-theme-main text-sm font-bold mb-2">
                                Dirección de Correo Electrónico:
                            </label>

                            <input id="email" type="email" class="bg-theme-level3 text-theme-inputs form-input border-theme-level2 w-full focus:outline-none focus:border-theme-level2 shadow-inner" name="email" value="" required autocomplete="email" autofocus>

                        </div>

                        <div class="flex flex-wrap mb-6">
                            <label for="password" class="block text-theme-main text-sm font-bold mb-2">
                                Contraseña:
                            </label>

                            <input id="password" type="password" class="bg-theme-level3 text-theme-inputs form-input border-theme-level2 w-full focus:outline-none focus:border-theme-level2 shadow-inner" name="password" required>
                        </div>

                        <div class="flex mb-6">
                            <label class="inline-flex items-center text-sm" for="remember">
                                <input type="checkbox" name="remember" id="remember" class="form-checkbox bg-theme-level3 border-theme-level2 shadow-inner">
                                <span class="ml-2 text-theme-main">Recordarme</span>
                            </label>
                        </div>

                        <div class="flex flex-wrap items-center">
                            <button type="submit" class="bg-theme-controls3 hover:bg-blue-700 text-gray-100 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                                Entrar
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        mounted() {
            /*console.log('The LOGIN component was mounted.');*/
            // Event.fire('closeSidebar');
        }
    }
</script>
